import type { App } from 'vue'
import Vue3Toastify from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

export function initToasts(app: App<Element>) {
  app.use(Vue3Toastify)
}
